import { istFarbwert, kontrastVerhaeltnis } from "./farben.js";
/**
 * Die TATSÄCHLICHEN Farbwerte hinter den Alias-Tokens, je Schema.
 *
 * Seit ME-Etappe 1 (Aufgabe 4) ist kundeninfo.css eine Alias-Schicht auf die Tokendatei von
 * me-design; diese Tabelle spiegelt die ALIAS-ZIELE (Vorgabe Meine Energie, also ohne
 * data-unternehmen): die ME-Werte wörtlich, die fünf `status*Bg` als ausgerechnetes
 * `color-mix(in srgb, <Ton> 12%, var(--flaeche))`, gerundet auf ganze Kanalwerte.
 * `border`/`borderStrong` sind in ME halbtransparent (rgba) und stehen hier ebenso —
 * die Kontrastprüfung legt sie auf den jeweiligen Grund.
 *
 * test/contrast.test.ts löst jeden Alias aus kundeninfo.css gegen die ME-Datei auf und hält
 * beides deckungsgleich; ändert sich ein Wert in me-design, fällt es dort auf.
 *
 * `border` und `borderStrong` sind ZWEI Aufgaben, nicht zwei Geschmäcker:
 * `border` trennt leise (Tabellenzeile, Kartenrand) und darf im Hintergrund bleiben,
 * `borderStrong` KONTURIERT ein Bedienelement und muss WCAG 1.4.11 (3:1) erfüllen — seit
 * me-design 9778a04 (--linie-stark 50 %) tut der ME-Wert das.
 */
export const PALETTE = {
    light: {
        bg: "#f9f9f7", surface: "#ffffff", surfaceRaised: "#eceee7",
        border: "rgba(11, 11, 11, 0.10)", borderStrong: "rgba(11, 11, 11, 0.5)",
        text: "#0b0b0b", muted: "#5f655f", accent: "#55811A", accentText: "#ffffff",
        statusOk: "#126a36", statusOkBg: "#e3ede7",
        statusRunning: "#416410", statusRunningBg: "#e8ece2",
        statusWarn: "#8a4308", statusWarnBg: "#f1e8e1",
        statusBad: "#b91c1c", statusBadBg: "#f7e4e4",
        statusOff: "#5f655f", statusOffBg: "#ecedec",
    },
    dark: {
        bg: "#0d0d0d", surface: "#211f1e", surfaceRaised: "#262824",
        border: "rgba(255, 255, 255, 0.10)", borderStrong: "rgba(255, 255, 255, 0.5)",
        text: "#ffffff", muted: "#898781", accent: "#ACCA68", accentText: "#0b0b0b",
        statusOk: "#5dd78b", statusOkBg: "#28352b",
        statusRunning: "#ACCA68", statusRunningBg: "#323427",
        statusWarn: "#f2b84b", statusWarnBg: "#3a3123",
        statusBad: "#f98a8a", statusBadBg: "#3b2c2b",
        statusOff: "#a5a39d", statusOffBg: "#312f2d",
    },
};
/**
 * Kontrastverhältnis nach WCAG 2.x. Text braucht mindestens 4,5:1.
 *
 * Nur noch ein ÜBERSETZER — gerechnet wird in `farben.ts::kontrastVerhaeltnis`
 * (Adjudikation (c) der UV-Abschlussprüfung). Hier stand bis dahin eine zweite,
 * gleichlautende Rechnung; zwei Antworten auf eine Frage laufen früher oder später
 * auseinander, und dann sagt der Palettentest etwas anderes als die Farbableitung.
 *
 * Übersetzt wird nur das FEHLERVERHALTEN. `kontrastVerhaeltnis` wirft bei allem, was keine
 * Farbe `#rrggbb` ist — dort ist das richtig: Eine Aktionsfarbe, die aus Unsinn abgeleitet
 * wird, soll laut scheitern statt still eine falsch aussehende Oberfläche zu bauen. Die
 * Aufrufer HIER (Kopfzeilen-Abzeichen) bekamen dagegen bisher stillschweigend NaN und
 * fragten `>= 4.5`; mit NaN ist das immer falsch, sie landeten also im Rückfall-Zweig.
 * Genau diesen Zweig hält die 1 fest — der kleinstmögliche Kontrast, „nicht lesbar":
 * `1 >= 4.5` ist ebenso falsch. Kein Aufrufer ändert sein Verhalten, und anders als NaN ist
 * 1 eine Antwort, mit der man weiterrechnen kann.
 *
 * Eine Verschärfung bleibt: Die alte Fassung nahm auch `rrggbb` OHNE Raute (sie schnitt
 * einfach nach `replace("#","")` weiter). Das tut sie nicht mehr — es gäbe sonst wieder
 * zwei Vorstellungen davon, was eine Farbe ist. Kein Aufrufer im Bestand ruft ohne Raute
 * (geprüft), und `company.colorHex` ist per `ck_company_color` auf `#rrggbb` festgelegt.
 */
export function contrastRatio(vorne, hinten) {
    if (!istFarbwert(vorne) || !istFarbwert(hinten))
        return 1;
    return kontrastVerhaeltnis(vorne, hinten);
}
//# sourceMappingURL=tokens.js.map